import { inject, Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { common } from '@qwyk/models';

import { CustomTagsActions } from './custom-tags.actions';
import * as CustomTagsSelectors from './custom-tags.selectors';

@Injectable()
export class CustomTagsFacade {

    private readonly store = inject(Store);

    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(CustomTagsSelectors.getCustomTagsLoading)
    );

    allCustomTags$ = this.store.pipe(
        select(CustomTagsSelectors.getAllCustomTags)
    );

    suggestions$ = this.store.pipe(
        select(CustomTagsSelectors.getSuggestions)
    );

    error$ = this.store.pipe(select(CustomTagsSelectors.getCustomTagsError));

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    init() {
        this.store.dispatch(CustomTagsActions.init());
    }

    public linkTagToEntity(request: { data: any, tagId: string, }) {
        this.store.dispatch(CustomTagsActions.linkTagToEntity(request));
    }

    public unlinkTagFromEntity(request: { tagId: string, entityId: string, entity: string }) {
        this.store.dispatch(CustomTagsActions.unlinkTagFromEntity(request));
    }

    public createTagAndLinkToEntity(request: { data: Partial<common.CustomTag>[] }) {
        this.store.dispatch(CustomTagsActions.tagEntity(request));
    }

    public searchTags(name: string) {
        this.store.dispatch(CustomTagsActions.searchTags({ name }));
    }

    public loadTags(query: any, isSuggestion = false) {
        this.store.dispatch(CustomTagsActions.loadTags({ query, isSuggestion }));
    }

    public updateTag(
        request: Partial<common.CustomTag>,
        entityId?: string
    ) {
        this.store.dispatch(
            CustomTagsActions.updateTag({ request, entityId })
        );
    }

    public reset() {
        this.store.dispatch(CustomTagsActions.reset());
    }
}
